"use strict";

var React = require("react");

var SvgIconGtLight24Px = function SvgIconGtLight24Px() {
  return /*#__PURE__*/ React.createElement(
    "svg",
    {
      width: "1em",
      height: "1em",
      viewBox: "0 0 6 10",
    },
    /*#__PURE__*/ React.createElement("path", {
      fill: "currentColor",
      d: "M0 1.167L1.104 0l4.73 5-4.73 5L0 8.833 3.626 5z",
    })
  );
};

exports["foreignIcon"] = SvgIconGtLight24Px;
